import { render, staticRenderFns } from "./upload-recording.component.vue?vue&type=template&id=7226b95e&"
import script from "./upload-recording.component.vue?vue&type=script&lang=js&"
export * from "./upload-recording.component.vue?vue&type=script&lang=js&"
import style0 from "./upload-recording.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports